import script from "./AssetImage.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetImage.vue?vue&type=script&setup=true&lang=js"

import "./AssetImage.vue?vue&type=style&index=0&id=e25a2bea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e25a2bea"]])

export default __exports__